angular.module('harriApp')
    .controller('EVerifyTrainingController', ['$scope', '$location', '$state', 'hUser', '$stateParams', function ($scope, $location, $state, hUser, $stateParams) {

        $scope.openChapters = false;
        $scope.brandId  = $stateParams.brand_id || hUser.getUserContext().brand_id;

        var sectionsPage = [];
        var disableScrollEvent = false;

        $scope.updateElement = function() {
            $('.chapters').trigger('heightChange');
        };

        $scope.getSectionId = function (chapterIndex, sectionIndex) {
            return $scope.chapters[chapterIndex].sections[sectionIndex].id;
        };


        $scope.selectSection = function (chapterIndex, sectionIndex, isNext) {

            if (!isNext && !$scope.chapters[chapterIndex].sections[sectionIndex].visited) {
                return;
            }
            setSectionAsVisited(chapterIndex, sectionIndex);

            $(".accordion").not(":eq(" + chapterIndex + ")").removeClass('open');

            $scope.selectedChapterIndex = chapterIndex;
            $scope.selectedSectionIndex = sectionIndex;

            $scope.openChapters = false; // for mobile view

            $scope.movedOnAllChapters = movedOnAllChapters();
        };

        $scope.nextChapter = function () {
            disableScrollEvent = true;
            var index = $scope.selectedChapterIndex + 1;
            if (index !== $scope.chapters.length) {
                $scope.selectSection(index, 0, true);
                triggerSection(index, $scope.chapters[index].sections[0].id);
            }


        };

        var movedOnAllChapters = function () {

            if ($scope.selectedChapterIndex !== $scope.chapters.length - 1) {
                return false;
            }

            OnBoardingAPI.finishTutorial($scope.brandId, hUser.getUser().id)
                .then(function (res) {
                    // Nothing to do

                }, function (error) {
                    console.error(error);
                });
            return true;
        };

        $scope.chapters = [
            {
                name: "Employee Civil Rights & Liberties, and Privacy",
                url: "../modules/training/e-verify/views/chapters/employee_civil_rights_lib_privacy.html",
                sections: [
                    {
                        name: "Privacy and Data Protections",
                        id: "privacy_and_data_protections"
                    },
                    {
                        name: "Employee Civil Rights and Civil Liberties",
                        id: "employee_civil_rights_and_civil_liberties"
                    },
                    {
                        name: "Rules and Responsibilities Overview",
                        id: "rules_and_responsibilities_overview"
                    },
                    {
                        name: "Privacy Breaches and Rights Violations",
                        id: "privacy_breaches_and_rights_violations"
                    }

                ]
            },
            {
                name: "E-Verify Process",
                url: "../modules/training/e-verify/views/chapters/e_verify_process.html",
                sections: [
                    {
                        name: "Overview",
                        id: "overview"
                    },
                    {
                        name: "Federal Contractor Requirements",
                        id: "federal_contractor_requirements"
                    },
                    {
                        name: "Form I-9 and E-Verify",
                        id: "form_I-9_and_e-verify"
                    },
                    {
                        name: "Hire Date",
                        id: "hire_date"
                    },
                    {
                        name: "Check Information Screen",
                        id: "check_information_screen"
                    },
                    {
                        name: "Error: Unexpired Document Required",
                        id: "error_unexpired_document_required"
                    },
                    {
                        name: "Photo Matching",
                        id: "photo_matching",
                    },
                    {
                        name: "Request Name Review",
                        id: "request_name_review",
                    },
                ]
            },
            {
                name: "Case Results",
                url: "../modules/training/e-verify/views/chapters/case_results.html",
                sections: [
                    {
                        name: "Initial Case Results",
                        id: "initial_case_results",
                    },
                    {
                        name: "Interim Case Results",
                        id: "interim_case_results",
                    },
                    {
                        name: "Tentative Nonconfirmation (TNC)",
                        id: "tnc"
                    },
                    {
                        name: "Final Case Results",
                        id: "final_case_results",
                    },
                    {
                        name: "Case Closure Statements",
                        id: "case_closure_statements",
                    }
                ]
            }

        ];



        var setSectionAsVisited = function (chapterIndex, sectionIndex) {
            $scope.chapters[chapterIndex].sections[sectionIndex].visited = true;
            var chapters = (HStorageManager.get({
                key: 'e_verify_training_visited_chapters_index',
                storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE
            }) || {});
            if (!chapters[chapterIndex]) {
                chapters[chapterIndex] = []
            }
            if (chapters[chapterIndex].indexOf(sectionIndex) < 0) {
                chapters[chapterIndex].push(sectionIndex);
                HStorageManager.put({
                    storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                    key: 'e_verify_training_visited_chapters_index',
                    value: chapters
                });
            }
        };

        $scope.beginTraining = function () {
            OnBoardingAPI.startTutorial($scope.brandId, hUser.getUser().id)
                .then(function (res) {
                    // Nothing to do
                }, function (error) {
                    console.error(error);
                });
            $state.go("appLayout.harriSH.training.e-verify_training", { brand_id: $scope.brandId });
        };

        var triggerSection = function (chapterIndex, sectionId) {
            // open the related chapter accordion
            var accordion = $('.accordion');
            accordion.eq(chapterIndex).addClass('open');
            setTimeout(function () {

                // clear if there is already hash value
                var noElem = $('a[href="#no-section"]');
                if (noElem.length) {
                    noElem.trigger('click');
                }

                var elem = $('a[href="#' + sectionId + '"]');
                if (elem.length) {
                    //click
                    elem.trigger('click');
                }
                disableScrollEvent = false;
            }, 100);

        };

        // init
        (function (){

            // set visited chapters from local storage
            var visitedChaptersIndex = HStorageManager.get({
                key: 'e_verify_training_visited_chapters_index',
                storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE
            });
            if (visitedChaptersIndex) {
                for (var chapterIndex in visitedChaptersIndex ) {
                    for (var visitedSectionIndex in visitedChaptersIndex[chapterIndex]) {
                        $scope.chapters[chapterIndex].sections[visitedSectionIndex].visited = true;
                    }
                }
            }

            $scope.selectedChapterIndex = 0;
            $scope.selectedSectionIndex = 0;

            var selectedChapter = 0;
            var selectedSection = -1;

            var hash = $location.hash() || $state.params.hash;

            if ( hash ) {

                for (var i in $scope.chapters) {
                    for (var j in $scope.chapters[i].sections) {
                        if (($scope.chapters[i].sections[j].id) === hash) {
                            selectedChapter = parseInt(i);
                            selectedSection = parseInt(j);
                        }
                    }
                }
            }


            setTimeout(function () {
                // programaticaly click on the anchor that has the section id
                if (selectedSection > 0) {
                    triggerSection(selectedChapter, $scope.chapters[selectedChapter].sections[selectedSection].id);
                } else {
                    triggerSection(selectedChapter);
                    if (selectedSection === 0) {
                        $scope.selectSection(selectedChapter, selectedSection);
                    }
                }

                $(window).on('scroll.everify', function(event) {

                    if (disableScrollEvent) {
                        return;
                    }

                    sectionsPage = $scope.chapters[$scope.selectedChapterIndex].sections.map(function (section, sectionIndex) {
                        if (sectionIndex === 0) {
                            return $('section').eq(0);
                        }

                        return $('#' + section.id);
                    });

                    if ( sectionsPage[0].length && $(this).scrollTop() + $(this).height() >= $(document).height() ) {
                        $scope.selectedSectionIndex = $scope.chapters[$scope.selectedChapterIndex].sections.length -1;
                        setSectionAsVisited($scope.selectedChapterIndex, $scope.selectedSectionIndex);
                    }

                    else {
                        var documentOffset = $(this).scrollTop() + $(this).height()/3;
                        for (var i in sectionsPage) {
                            if (sectionsPage[i].offset() && sectionsPage[i].offset().top < documentOffset &&
                                    sectionsPage[i].offset().top + sectionsPage[i].height() - 75 > documentOffset) {
                                $scope.selectedSectionIndex = parseInt(i);
                                setSectionAsVisited($scope.selectedChapterIndex, $scope.selectedSectionIndex);
                            }
                        }
                    }
                    try {
                        $scope.$digest();
                    }catch(e) {

                    }
                });

            }, 100);
        })();

        $scope.$on("$destroy", function() {
            $(window).off("scroll.everify");
        });

    }]);
